import React, { useMemo } from 'react';
import { IRealtimeOpinions } from './type';
import { connect } from 'umi';
import { Layout, Tabs } from 'tea-component';
import ContentBody from '@op/components/ContentBody';
import useLanguage from '@op/hooks/useLanguage';
import { PAGE_NAME } from '@op/constants/page';
import { realtimeOpinionsTips, realtimeOpinionHeaderTips } from '@op/components/BubbleCommon';
import './index.scss';
import useTabHistory from '@op/hooks/useTabHistory';
import KeyMetricsOverview from './pages/KeyMetricsOverview';
import LanguagePerformance from './pages/LanguagePerformance';
import ChannelPerformance from './pages/ChannelPerformance';
import { DBO_TM } from '@op/utils/format';
import { useInitBuriedPointInfo } from '@op/operationLog/buriedPoint';
import RealtimeOpinionsPoint from '@op/operationLog/pages/RealtimeOpinions';

const { Content } = Layout;
const RealtimeOpinions = (props: IRealtimeOpinions) => {
  const { gameInfo, wholeGameInfo } = props;
  const { formatMessage } = useLanguage();
  const { tab: activeId, onActive } = useTabHistory({
    defaultValue: 'overview',
  });
  useInitBuriedPointInfo({ buriedPoint: RealtimeOpinionsPoint });
  const tabs = useMemo(
    () => [
      {
        id: 'overview',
        label: formatMessage({
          id: 'Key Metrics Overview',
        }),
      },
      {
        id: 'language',
        label: formatMessage({
          id: 'Language Performance',
        }),
      },
      {
        id: 'channel',
        label: formatMessage({
          id: 'Channel Performance',
        }),
      },
    ],
    [formatMessage],
  );

  const realtimeUTCTips = useMemo(() => {
    const timezone = DBO_TM.timezone();
    const result = Object.fromEntries(
      Object.entries(realtimeOpinionsTips).map(([key, value]) => [
        key,
        typeof value === 'string' ? value.replace(`$UTC`, `UTC+${timezone}`) : value,
      ])
    );
    return result;
  }, [realtimeOpinionsTips]);

  return (
    <Content className="dbo-page-realtime-opinions">
      <ContentBody
        horseRaceLampTips={[realtimeUTCTips, realtimeOpinionHeaderTips]} 
        noShowTimeZoneTips={true}
        contentHeard={
          <Content.Header
            className="dbo-header contentHead-normal"
            title={formatMessage({ id: PAGE_NAME.REALTIME_OPINIONS })}
          >
            <div className="header-tab">
              <Tabs
                ceiling
                tabs={tabs}
                animated={false}
                activeId={activeId}
                onActive={onActive}
              />
            </div>
          </Content.Header>
        }
      // pageName={PAGE_NAME.TRENDING_PUBLICATIONS}
      >
        <>
          {activeId === 'overview' && (
            <KeyMetricsOverview
              gameInfo={gameInfo}
              wholeGameInfo={wholeGameInfo}
              onActive={() => onActive({ id: 'channel' })}
            />
          )}
          {activeId === 'language' && (
            <LanguagePerformance
              gameInfo={gameInfo}
              wholeGameInfo={wholeGameInfo}
            />
          )}
          {activeId === 'channel' && (
            <ChannelPerformance
              gameInfo={gameInfo}
              wholeGameInfo={wholeGameInfo}
            />
          )}
        </>
      </ContentBody>
    </Content>
  );
};

export default connect((state: any) => {
  const { opinionCommon } = state;
  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(RealtimeOpinions);
